import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AssignTrainingComponent } from './components/assign-training/assign-training.component';
import { TncDashboardComponent } from './components/tnc-dashboard/tnc-dashboard.component';
import { TncConstantsService } from './services/tnc-constants.service';
import { TrainingAndCompetencyService } from './services/training-and-competency.service';
import { TrainingAndCompetencyRoutingModule } from './training-and-competency-routing.module';
import { UserProfileComponent } from './components/user-profile/user-profile.component';

@NgModule({
  declarations: [AssignTrainingComponent, TncDashboardComponent, UserProfileComponent],
  imports: [
    CommonModule,
    TrainingAndCompetencyRoutingModule,
    SharedModule
  ],
  providers: [
    TncConstantsService,
    TrainingAndCompetencyService,
  ]
})
export class TrainingAndCompetencyModule { }
